"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCountryTranslation = void 0;
const React = require("react");
const app_1 = require("app");
const useCountryTranslation = (config) => {
    const { apiUrl, locationApiKey, culture, enabled = true } = config;
    const [dictionary, setDictionary] = React.useState({});
    const [isLoading, setIsLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    React.useEffect(() => {
        if (!enabled || !apiUrl || !locationApiKey || !culture) {
            setDictionary({});
            setIsLoading(false);
            setError(null);
            return;
        }
        const countryService = new app_1.CountryService({
            apiUrl,
            locationApiKey,
            culture,
            keyMode: app_1.LocationKeyModeEnum.Code,
            prefixNeeded: true,
        });
        let isCancelled = false;
        setIsLoading(true);
        setError(null);
        countryService
            .getTranslatedCountriesObjectByCountryCode()
            .then(result => {
            if (isCancelled) {
                return;
            }
            setDictionary(result || {});
        })
            .catch(loadError => {
            if (isCancelled) {
                return;
            }
            setDictionary({});
            setError(loadError instanceof Error ? loadError : new Error('Failed to load countries'));
        })
            .finally(() => {
            if (!isCancelled) {
                setIsLoading(false);
            }
        });
        return () => {
            isCancelled = true;
        };
    }, [apiUrl, locationApiKey, culture, enabled]);
    return {
        countryFilterDictionary: dictionary,
        isLoading,
        error,
    };
};
exports.useCountryTranslation = useCountryTranslation;
